// extracted by mini-css-extract-plugin
export default {"cartContainer":"SM","summarycontent":"TM","offset":"UM","leaf":"VM","summaryclosed":"WM","summaryheader":"XM","summaryitems":"YM","summaryprice":"ZM","buttonopen":"aN","buttondown":"bN","summaryfixed":"cN","usdnotification":"eN","renew":"fN","promowrapper":"gN","ordersummarywrap":"hN","simplewrap":"iN"};
    if(module.hot) {
      // 1713912566343
      var cssReload = require("../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  